import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { toPascalCase } from '@cli-utils/text.js'

export function buildGroupSelectState(fields: SchemaField[]): string {
  return fields
    .map(
      (field) =>
        `  const [${field.name}Open, set${toPascalCase(field.name)}Open] = React.useState(false)`
    )
    .join('\n')
}
